<template>
  <div class="table-responsive">
    <table id="datatable-basic" class="table table-flush">
      <thead class="thead-light">
      <tr>
        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
          #
        </th>
        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
          {{ $t("Nome") }}
        </th>
        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
          {{ $t("Posizione") }}
        </th>
        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" data-sortable="false">
          {{ $t("Azioni") }}
        </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="e in listini" :key="'listino-datatable-'+e.id">
        <td><strong>{{ e.id }}</strong></td>
        <td v-if="lang === 'it'">{{ e.descrizione }}</td>
        <td v-else-if="lang === 'en'">{{ e.descrizione_en }}</td>
        <td v-else-if="lang === 'de'">{{ e.descrizione_de }}</td>
        <td>{{ e.posizione }}</td>
        <td>
          <router-link :to="{name:'Listino', params:{id: e.id}}">
            <argon-button size="sm">{{$t('Vedi')}}</argon-button>
          </router-link>
          <argon-button class="ms-1" size="sm" color="danger" @click.prevent="remove(e.id)"><span class="fa fa-trash-can"></span></argon-button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { DataTable } from "simple-datatables";
import ArgonButton from "@/components/ArgonButton.vue";
import {removeModal} from "@/modals";
import {mapState} from "vuex";

export default {
  name: "ListiniDataTable",
  components: {
    ArgonButton
  },
  props: {
    listini: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState(["lang"]),
  },
  mounted() {
    // eslint-disable-next-line no-unused-vars
    new DataTable("#datatable-basic", {
      searchable: true,
      fixedHeight: true,
      paging: false,
      labels: {
        placeholder: this.$t("Cerca..."),
        searchTitle: this.$t("Cerca nella tabella"),
        perPage: this.$t("elementi per pagina"),
        pageTitle: this.$t("Pagina page").replaceAll('[', '{').replaceAll(']', '}'),
        noRows: this.$t("Nessun elemento trovato"),
        noResults: this.$t("Nessun risultato per la tua query di ricerca"),
        info: this.$t("Risultati da start a end su rows").replaceAll('[', '{').replaceAll(']', '}'),
      }
    });
  },
  methods: {
    remove: function(id){
      removeModal(this, () => {
        this.apiClient.removeListino(id).then(() => {
          location.reload();
        });
      });
    }
  }
};
</script>
